<div class="media">
  <img class="d-flex mr-3 listing-photo rounded"
    [alt]="listing.profile.firstname + ' ' + listing.profile.lastname"
    [src]="listing.profile.photoThumb ? listing.profile.photoThumb : dummyPhoto"
    (error)="onImgError($event)">
  <div class="media-body">
    <h5 class="mt-0 font-weight-bold">{{ listing.profile.firstname }} {{ listing.profile.lastname }},
      <small>{{ listing.profile.honorific }}</small></h5>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col">
            <div class="content">
              <p class="d-flex flex-column">
                <span [innerHTML]="listing.profile.position"></span>
                <span [innerHTML]="listing.profile.rank"></span>
                <span [innerHTML]="listing.department"></span>
                <span [innerHTML]="listing.school"></span>
                <a [href]="'mailto:' + listing.profile.email" class="blue-text">{{ listing.profile.email }}</a>
              </p>
            </div>
          </div>
          <div class="col d-flex justify-content-end align-items-end">
            <div class="action d-flex justify-content-end">
            <button type="button" class="btn btn-outline-secondary btn-sm shadow-sm"
              [routerLink]="['/profile', listing.profile.id]"
              [attr.aria-label]="'View profile for ' + listing.profile.firstname + ' ' + listing.profile.lastname">View</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>